import { LocktubeData } from '../../constants/containerManagerInterfaces';

export const getFilledStorageNames = (storageState: LocktubeData) => {
  let nameArray: string[] = [];
  for (const [container, status] of Object.entries(storageState.tubes)) {
    if (status.filled && !status.disabled) {
      nameArray.push(container);
    }
  }
  return nameArray;
};
